import {registerPaginationTriggers} from "./overview-pagination";
import config from './config.json';
import {bindJobAlertPopup} from "./job-alert";

const showVacancyPlaceholders = () => {
	const vacancyCards = document.querySelectorAll("[data-vacancy-card]");
	const placeHolder = document.querySelector("[data-vacancy-card-placeholder]");

	vacancyCards.forEach(card => card.replaceWith(placeHolder.cloneNode(true)));

	const vacancyCount = document.getElementById("vacancy-count");
	const vacancyCountPlaceHolder = document.getElementById("vacancy-count-placeholder");
	vacancyCount.innerText = vacancyCountPlaceHolder.innerText;
}

const showResults = () => {
	registerPaginationTriggers();
	bindJobAlertPopup();
}

let loading = false;
export const updateResultView = async () => {
	if (!loading) {
		loading = true;
		showVacancyPlaceholders();

		const results = document.getElementById("result-view");
		const response = await fetch(`${config.basepath}/overview/search${window.location.search}`);
		if (response.ok) {
			results.innerHTML = await response.text();
		} else {
			results.innerHTML = response.statusText;
		}

		showResults();
		loading = false;
	}
}
